import { withAuthUser } from 'next-firebase-auth'
import * as Page from 'views/typing-mentor-coach'

export default withAuthUser({})(Page.TypingMentorCoach)
